import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {ItemDefinitionSimpleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {
  ActiveInactivePills,
  YesNoPills,
} from 'src/shared/constants/PillConstants';
import {
  ActiveStateDataOptions,
  YesNoStateDataOptions,
} from 'src/shared/constants/columnFilterData';

export const useItemDefinitionColumns = () => {
  const columns = useMemo<MRT_ColumnDef<ItemDefinitionSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        accessorKey: 'creator.name',
        header: 'Created By',
      },
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ActiveStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean>();
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'isRequestable',
        header: 'Requestable',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: YesNoStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean>();
          const pillConfig = YesNoPills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
